<template>
  <div>
    <header-navigation></header-navigation>
    <div class="page sleep-blog-single">
      <blog-breadcrumb
        v-bind:origin="'single'"
        v-bind:title="content.post_title"
      >
      </blog-breadcrumb>
      <div class="container post px-xs-sm-2">
        <div class="row my-5">
          <div class="col-md-12 mx-auto">
            <header>
              <h1 class="pt-3 pb-2 m-0 text-center heading-lg">
                {{ content.post_title }}
              </h1>
              <div class="meta">
                <div class="tags"></div>

                <ratings
                  v-bind:type="'blog-post'"
                  v-bind:id="content.ID"
                ></ratings>
              </div>
            </header>

            <div class="content" v-html="content.post_content"></div>
          </div>
        </div>
      </div>
      <component-d2255999
        v-bind:acf="content.related_articles"
        v-bind:heading="content.related_articles.heading"
      >
        <eyebrow-icon
          v-bind:eyebrowicon="{ color: 'black', icon: 'paperclip' }"
          v-bind:align="'center'"
        ></eyebrow-icon>
      </component-d2255999>
      <!-- share -->
      <component-d3661978
        v-bind:acf="{ layout: { 'background-color': '#F1F4F7' } }"
      ></component-d3661978>
    </div>
     <a href="#" class="to-top active">
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        border-radius=20%
        fill="none"
        style="background-color:#0D0A15"
        stroke-width="2"
      stroke-linecap="round"
      stroke="white"
      >
        <path d="M18 15l-6-6-6 6" />
      </svg>
      </a>
    <footer>
      <nav class="company-pages px-3 px-md-0">
        <div class="container">
          <div class="">
            <footer-navigation
              v-bind:category="'quick-links'"
            ></footer-navigation>
          </div>
          <hr class="d-none d-md-block" />

          <div class="row">
            <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
              <footer-navigation
                v-bind:category="'useful-links'"
              ></footer-navigation>
            </div>

            <div class="col-lg-4">
              <social-media></social-media>
              <div class="copyright-disclaimers d-none d-md-block">
                <p><span>© ResMed</span> {{ $getTranslation("All rights reserved.", $route.params.region) }}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </footer>
  </div>
</template>

<script>
import jsonData from "./assets/data-blog.json";
// import group from "./components/navigation/group.vue";
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import socialMedia from "./components/navigation/social-media.vue";
import ratings from "./components/shared-support/ratings.vue";
import wpApi from "./services/wpApi";

export default {
  components: { headerNavigation, footerNavigation, socialMedia, ratings },
  data() {
    return {
      content: {},
      metaData: {},
    };
  },
  name: "App",
  metaInfo() {
    return {
      title: this.metaData.title || "Resmed Product Support",
      meta: [
        { name: "description", content: this.metaData.description },
        { name: " title", content: this.metaData.title },
      ],
    };
  },
  created() {},
  async mounted() {
    try {
      const data = await wpApi.getArticleBySlug(
        this.$route.params.region,
        this.$route.params.article
      );
      this.content = data.data[0];
      this.metaData = {
        title: data.data.metatitle,
        description: data.data.metadesc,
      };
      this.pageNotFound(data.data[0].post_title);
    } catch (e) {
      this.pageNotFound();
    }
    // const toTop=document.querySelector(".to-top");
window.addEventListener("scroll",() =>{
   let toTop=document.querySelector(".to-top");
  console.log("toTop",toTop.classList);
  if(window.pageYOffset >200) {
    toTop.classList.add("active");
  }
  else{
    toTop.classList.remove("active");
  }
});
  },
  computed: {
    myFields: () => JSON.parse(JSON.stringify(jsonData))[0],
  },
  methods: {
    pageNotFound(data) {
      if (data == null) {
        this.$router.push({
          name: "404",
          params: {
            region: this.$route.params.region,
            slug: "-page-sleep-apnea",
          },
        });
      }
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.to-top {
  color:white;
  position: fixed;
  bottom: 16px;
  right: 40px;
  width: 100px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  text-decoration: none;
  opacity: 0;
  pointer-events: none;
  scroll-behavior: smooth;
  /* transition: all .4s; */
  }
.to-top.active{
  bottom: 32px;
  pointer-events: auto;
  opacity: 1;
}
@media (max-width: 768px) {
  .to-top {
    right: 0;
  }
}
</style>
